import React, {useRef} from 'react';
import {Box, HStack, IconButton, Tag, Text} from '@chakra-ui/react';
import {ProfilUBItem} from 'api-types/ffconnect';
import {useHorizontalScroll} from '@/hooks/useHorizontalScroll';
import {ChevronLeftIcon} from '@/components/svg/ChevronLeftIcon';
import {ChevronRightBlueIcon} from '@/components/svg/ChevronRightBlueIcon';
import {DisplayStatus} from '@/components/ub/StatusDisplay';

// Barre de tags scrollable horizontalement (un par item UB).
export const MesProduitsUBTags: React.FC<{items: ProfilUBItem[]}> = ({
  items,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const {canScrollLeft, canScrollRight, scrollToStart, scrollToEnd} =
    useHorizontalScroll(scrollRef);

  // Scroll vers la section correspondante au clic sur un tag (id = `ub-section-{item.id}`)
  // L'offset (Navbar, plus la barre filtres + tags en md+) vient du `scrollMarginTop`
  // posé sur la section, égal au `top` sticky de son header.
  const onTagClick = (item_id: string) => {
    const element = document.getElementById(`ub-section-${item_id}`);
    if (!element) return;
    element.scrollIntoView({behavior: 'smooth', block: 'start'});
  };

  return (
    <Box
      position='relative'
      w='100%'
    >
      {canScrollLeft && (
        <Box
          position='absolute'
          left={0}
          top={0}
          bottom={0}
          w='30px'
          zIndex={1}
          pointerEvents='none'
          bgGradient='linear(to-r, white 70%, transparent)'
        />
      )}
      {canScrollRight && (
        <Box
          position='absolute'
          right={0}
          top={0}
          bottom={0}
          w='30px'
          zIndex={1}
          pointerEvents='none'
          bgGradient='linear(to-l, white 70%, transparent)'
        />
      )}
      {canScrollLeft && (
        <IconButton
          aria-label='Précédent'
          icon={<ChevronLeftIcon color='white' />}
          position='absolute'
          left={1}
          top='50%'
          transform='translateY(-50%)'
          zIndex={2}
          bg='gray.dark'
          borderRadius='full'
          h='19px'
          w='19px'
          minW='19px'
          p='0'
          _hover={{bg: 'black.text'}}
          onClick={scrollToStart}
        />
      )}
      {canScrollRight && (
        <IconButton
          aria-label='Suivant'
          icon={<ChevronRightBlueIcon color='white' />}
          position='absolute'
          right={1}
          top='50%'
          transform='translateY(-50%)'
          zIndex={2}
          bg='gray.dark'
          borderRadius='full'
          h='19px'
          w='19px'
          minW='19px'
          p='0'
          _hover={{bg: 'black.text'}}
          onClick={scrollToEnd}
        />
      )}
      <HStack
        ref={scrollRef}
        spacing={2}
        py='2'
        overflowX='auto'
        css={{
          '&::-webkit-scrollbar': {display: 'none'},
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        {items.map((item) => (
          <Tag
            key={item.id}
            cursor='pointer'
            h='39px'
            borderRadius='12px'
            bg='gray.light_bg'
            color='gray.dark'
            fontWeight='600'
            flexShrink={0}
            onClick={() => {
              onTagClick(item.id);
            }}
            _hover={{bg: 'gray.bg'}}
          >
            <HStack spacing={2}>
              <DisplayStatus
                status={item.statut}
                size={3.5}
              />
              <Text
                fontSize='xs'
                fontWeight='500'
              >
                {item.nom}
              </Text>
            </HStack>
          </Tag>
        ))}
      </HStack>
    </Box>
  );
};
